import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-spf50-sunscreen',
  imports: [UpsellCardComponent],
  templateUrl: './spf50-sunscreen.html',
  styleUrl: './spf50-sunscreen.scss',
})
export class Spf50Sunscreen {
  public readonly slug: UpsellSlugs = UpsellSlugs.Spf50Sunscreen;
}
